import gql from 'graphql-tag';
import FRAGMENTS from '_Resources/Cards/Services/GraphQl/FRAGMENTS';

const query = gql`
  query getEindexTemperatureCardData(
    $projectId: Int!
    $range: DateRangeInput!
    $criteriaKeys: [CriteriaKey!]
    $thematics: [ThematicInput!]
    $keywords: [String!]
    $dataCollectorId: Int
  ) {
    results: getEindexTemperatureCardData(
      projectId: $projectId
      range: $range
      criteriaKeys: $criteriaKeys
      thematics: $thematics
      keywords: $keywords
      dataCollectorId: $dataCollectorId
    ) {
      eindex {
        ...KpiResultsFragment
      }
      emotions {
        ...EmotionsBreakdownFragment
      }
      benchmarkParent {
        name
        value
      }
    }
  }
  ${FRAGMENTS.kpiResults}
  ${FRAGMENTS.emotionsBreakdown}
`;
export default query;
